<script>
  import { _ } from 'svelte-i18n';

  export let nextPage;
  export let prevPage;
  export let toPage;
  export let metaData;

  export let currentPage;
  export let pageCount;

  function showPageNumber(index) {
    // Check if currentPage is First or Last page
    if ((currentPage == 1 || currentPage == pageCount) && index != 1 && index != pageCount) {
      if ((index - currentPage > 0 && index - currentPage < 5) || (currentPage - index > 0 && currentPage - index < 5)) {
        return true;
      }
    } else if (index != 1 && index != pageCount) {
      if ((index - currentPage >= 0 && index - currentPage < 4) || (currentPage - index >= 0 && currentPage - index < 4)) {
        return true;
      }
    }
    return false;
  }
</script>

<div class="page-picker">
  <div on:click="{prevPage}" class="page-picker-next {metaData.previous ? 'page-picker-pages-page' : 'mod-nomore'}" aria-label="{$_('common.previous_page')}">
    &#60;&nbsp;&nbsp;{$_('common.previous_page')}
  </div>
  <div class="page-picker-pages" aria-label="{$_('common.page')} {currentPage} / {pageCount}">
    <span>{$_('common.page')}</span>

    <!-- FIRST -->
    <span><span on:click={() => toPage(1)} class="page-picker-pages-page {1 === currentPage ? 'mod-current' : ''}">1</span></span>
    {#if pageCount > 1}
      <span>|</span>
    {/if}

    {#if currentPage - 1 > 4}
      <span>...|</span>
    {/if}

    {#each Array(pageCount) as _, index}
      {#if showPageNumber(index + 1) && currentPage > 0}
        <span><span on:click={() => toPage(index+1)} class="page-picker-pages-page {(index + 1) === currentPage ? 'mod-current' : ''}">{index + 1}</span>|</span>
      {/if}
    {/each}

    {#if pageCount - currentPage > 4}
      <span>...|</span>
    {/if}

    <!-- LAST -->
    {#if pageCount > 1}
      <span><span on:click={() => toPage(pageCount)} class="page-picker-pages-page {pageCount === currentPage ? 'mod-current' : ''}">{pageCount}</span></span>
    {/if}
  </div>
  <div on:click="{nextPage}" class="page-picker-next {metaData.next ? 'page-picker-pages-page' : 'mod-nomore'}" aria-label="{$_('common.next_page')}">
    {$_('common.next_page')}&nbsp;&nbsp;&#62;
  </div>
</div>
